import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { dracula } from "react-syntax-highlighter/dist/esm/styles/prism";

const TypingResponseRenderer = ({ fullResponse, isNewMessage, onTyping }) => {
  const [typedResponse, setTypedResponse] = useState(isNewMessage ? "" : fullResponse);

  useEffect(() => {
    if (!fullResponse || typeof fullResponse !== "string") {
      console.error("Invalid fullResponse:", fullResponse);
      return;
    }

    if (!isNewMessage) {
      setTypedResponse(fullResponse);
      return;
    }

    // Typing animation for new messages
    let typingIndex = 0;
    const trimmedResponse = fullResponse.trim();
    const interval = setInterval(() => {
      if (typingIndex < trimmedResponse.length) {
        setTypedResponse((prev) => prev + trimmedResponse.charAt(typingIndex));
        typingIndex++;
        onTyping(); // Notify parent of typing progress
      } else {
        clearInterval(interval);
      }
    }, 1);

    return () => clearInterval(interval);
  }, [fullResponse, isNewMessage, onTyping]);

  return (
    <div style={{ padding: '15px' }}>
      {typedResponse ? (
        <ReactMarkdown
          components={{
            code({ node, inline, className, children, ...props }) {
              const match = /language-(\w+)/.exec(className || "");
              return !inline && match ? (
                <SyntaxHighlighter style={dracula} language={match[1]} PreTag="div" {...props}>
                  {String(children).replace(/\n$/, "")}
                </SyntaxHighlighter>
              ) : (
                <code className={className} {...props}>
                  {children}
                </code>
              );
            },
          }}
        >
          {typedResponse}
        </ReactMarkdown>
      ) : (
        <div>...</div> // Placeholder while typing
      )}
    </div>
  );
};

export default TypingResponseRenderer;
